import React from 'react';

import { Flex } from 'antd';

import { CopyableText } from './CopyableText';

export const ChangedById = ({ id }: { id: string }) => (
  <Flex justify="flex-end">
    <CopyableText value={id} />
  </Flex>
);
